import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CustomerListModel, CustomerShippingDataModel } from '../../variables/customer';
import { CustomerService } from '../../services/customer.service';
import { SortColumn, SortDirection } from '../../services/sortable.directive';
import { compare } from '../../variables/constant';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CustomerInfoModalComponent } from 'src/app/components/customer-info-modal/customer-info-modal.component';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';

@Component({
  selector: 'app-customer-update-request',
  templateUrl: './customer-update-request.component.html',
  styleUrls: ['./customer-update-request.component.scss']
})
export class CustomerUpdateRequestComponent implements OnInit {

  searchResultListAll: CustomerListModel[] = [];
  searchResultList: CustomerListModel[];
  isLoading: boolean = false;
  isLoadingoverlay: boolean = false;
  //paging
  collectionSize: number = 0;
  page: number = 1;
  pageSize: number = 10;
  //search
  searchTerm: string = "";
  searchSubject: Subject<string> = new Subject();
  //sorting
  currentColumn: SortColumn = "";
  currentSortBy: SortDirection = "desc";
  companyCode = localStorage.getItem('company_code');
  selectedIds: any[] = [];
  sortedField;
  isDescending = true;

  constructor(
    private customerService: CustomerService,
    private activeModal: NgbModal) {
  }

  ngOnInit(): void {
    this.loadData();

    this.searchSubject.pipe(
      debounceTime(500), // Wait for 500ms pause in typing
      distinctUntilChanged() // Ignore if next search term is same as previous
    ).subscribe((searchText) => {
      this.searchTerm = searchText;
      this.loadData();
    });
  }

  loadData() {
    this.isLoading = true;
    let payload = {
      page: this.page || 1,
      size: this.pageSize || 10,
      search: this.searchTerm || null,
      sortedField: this.sortedField || "customerNumber",
      isDescending: this.isDescending
    }

    this.customerService
      .getCustomersUpdateRequests(this.companyCode, payload)
      .subscribe((res: any) => {
        this.isLoading = false;
        if (res && res['result']) {
          this.searchResultListAll = res['result'];
          this.searchResultList = res['result'];
          this.collectionSize = res?.totalRecords || res['result']?.length;
        } else {
          this.searchResultListAll = [];
          this.searchResultList = [];
          this.collectionSize = 0;
        }
      }, () => {
        this.isLoading = false;
        this.searchResultListAll = [];
        this.searchResultList = [];
        this.collectionSize = 0;
      })
  }

  changePage(e) {
    this.page = e;
    this.loadData();
  }

  resetCustomerPage() {
    this.page = 1;
    this.loadData();
  }

  onSearchChange(searchText: string) {
    this.page = 1;
    this.searchSubject.next(searchText);
  }

  approveCustomer(id: any) {
    const confirmed = confirm('Are you sure you want to approve ?');
    if (confirmed) {
      this.customerService.approveCustomerMaster(id).subscribe((res) => {
        if (res) {
          this.loadData();
        }
      }, (error) => {
        if (error instanceof Object) {
          if (error["ResponseException"] != "") {
            alert(error["ResponseException"]);
          }
        }
      })
    }
  }

  onSort(event) {
    // this.page = 1; //bring back to page 1
    var column = event.target.getAttribute("sortable");
    this.sortedField = column;
    if (this.currentColumn !== column && this.currentColumn !== "") {
      this.currentColumn = column;
      this.currentSortBy = "asc"; //revert to default sort      
    } else {
      if (this.currentColumn == "") { //first sort
        this.currentColumn = column;
        if (this.currentColumn == "customerName") { //by default, customerName is already sorted to asc
          this.currentSortBy = "desc";
        }
      } else {
        if (this.currentSortBy == "asc") {
          this.currentSortBy = "desc";
        } else {
          this.currentSortBy = "asc";
        }
      }
    }
    this.isDescending = this.currentSortBy == "desc" ? true : false;
    this.page = 1;
    this.loadData();
    // this.searchResultList = this.sortData(this.searchResultList, column, this.currentSortBy);
  }

  searchData(_term: string) {
    let term = _term.toLowerCase();
    this.searchTerm = term;
    if (_term == "") {
      this.searchResultList = this.searchResultListAll;
    }
    else {
      this.searchResultList = this.searchResultListAll.filter(data =>
        (data.customerName == null ? "" : data.customerName).toLowerCase().indexOf(term) > -1
        || (data.phoneNumber == null ? "" : data.phoneNumber).toLowerCase().indexOf(term) > -1
        || (data.email == null ? "" : data.email).toLowerCase().indexOf(term) > -1
        || (data.payorAccountNumber == null ? "" : data.payorAccountNumber).toLowerCase().indexOf(term) > -1
        || (data.dateModified == null ? "" : data.dateModified).toLowerCase().indexOf(term) > -1
        || (data.status == null ? "" : data.status).toLowerCase().indexOf(term) > -1
      );
    }
    this.collectionSize = this.searchResultList.length;
    this.page = 1;
  }

  sortData(datalist: any[], column: SortColumn, direction: SortDirection): any[] {
    if (direction === '' || column === '') {
      return datalist;
    } else {
      return [...datalist].sort((a, b) => {
        const res = compare(a[column], b[column]);
        return direction === 'asc' ? res : -res;
      });
    }
  }

  openInfoModal() {
    const modalRef = this.activeModal.open(CustomerInfoModalComponent, { centered: true, size: 'lg', ariaLabelledBy: 'customerInfoModalTitle' });
    modalRef.result.then(
      (data: any) => {
      },
      (reason: any) => {
        console.log(reason);
      }
    );
  }

  onApproveModal(customerId) {
    const modalRef = this.activeModal.open(CustomModalComponent, { centered: true, ariaLabelledBy: 'customModalTitle' });
    modalRef.componentInstance.title = "Approve Request";
    modalRef.componentInstance.description = "Are you sure you want to approve the changes?";
    modalRef.componentInstance.infoIcon = "./assets/img/ExclamationCircle.png";
    modalRef.componentInstance.btnText = "Yes, Approve";
    modalRef.result.then(
      (data: any) => {
        if (data == "ok") {
          this.approve(customerId);
        }
      },
      (reason: any) => {
        console.log(reason);
      }
    );
  }

  onDenyModal(customerId) {
    const modalRef = this.activeModal.open(CustomModalComponent, { centered: true, ariaLabelledBy: 'customModalTitle' });
    modalRef.componentInstance.title = "Deny Request";
    modalRef.componentInstance.description = "Are you sure you want to deny the changes?";
    modalRef.componentInstance.infoIcon = "./assets/img/ExclamationCircle.png";
    modalRef.componentInstance.btnText = "Yes, Deny";
    modalRef.result.then(
      (data: any) => {
        if (data == "ok") {
          this.deny(customerId);
        }
      },
      (reason: any) => {
        console.log(reason);
      }
    );
  }

  approve(customerId) {
    this.isLoadingoverlay = true;
    this.customerService
      .approveCustomerDetails(customerId)
      .subscribe((res: any) => {
        this.isLoadingoverlay = false;
        if (res && res['status'] == "Success") {
          alert(res['message']);
          this.loadData();
        } else {
          alert(res['message'] || "Something went wrong! Please try again.");
        }
      });
  }

  deny(customerId) {
    this.isLoadingoverlay = true;
    this.customerService
      .denyCustomerDetails(customerId)
      .subscribe((res: any) => {
        this.isLoadingoverlay = false;
        if (res && res['status'] == "Success") {
          alert(res['message']);
          this.loadData();
        } else {
          alert(res['message'] || "Something went wrong! Please try again.");
        }
      });
  }
}

